import { render, staticRenderFns } from "./RefereesCard.vue?vue&type=template&id=3907481e&scoped=true"
import script from "./RefereesCard.vue?vue&type=script&lang=js"
export * from "./RefereesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907481e",
  null
  
)

export default component.exports